export default "__VITE_ASSET__Haw4V5kR__"